export default {
  INTEGER: 'INTEGER',
  TEXT: 'TEXT',
  NUMERIC: 'NUMERIC',
  BOOLEAN: 'BOOLEAN',
  TINYINT: 'TINYINT'
}



// WEBPACK FOOTER //
// ./src/modules/storage/dbTypes.js